import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";

/** נתיב ייעודי עתידי — payload קל לעמוד הבית של חבילות */
export const VACATION_PACKAGES_HOME_FEED_PATH = "/api/vacation-packages/home-feed";

/** מספיק מערך טיסות; יעדי חבילות נטענים בנפרד לפי יעד קבוע ב-FE */
function isValidHomeFeedShape(data) {
  if (!data || typeof data !== "object") return false;
  return Array.isArray(data.flights);
}

/**
 * ניסיון לטעון טיסות מ-home-feed; חבילות לפי יעד לא משתמשות בזה.
 * @returns {Promise<{ flights: object[] } | null>}
 */
export async function fetchVacationPackagesHomeFeedFromDedicatedEndpoint(signal) {
  try {
    const url = resolveApiUrl(VACATION_PACKAGES_HOME_FEED_PATH);
    const res = await axios.get(url, {
      signal,
      timeout: 14_000,
      validateStatus: (s) => s === 200,
    });
    const data = res?.data;
    if (isValidHomeFeedShape(data)) {
      return {
        flights: data.flights,
      };
    }
  } catch {
    /* 404 / רשת — נופל חזרה ללקוח הקיים */
  }
  return null;
}
